import { create } from 'zustand';

// export const useTestStore = create()(
//   devtools(
//     persist(
//       (set) => ({
//         testTitle: '',
//         testDetail: '',
//         technology_Used: [],
//         duration: 15,
//         profile:'',
//         questions: [],
//         updateTitle: (title) => set({ testTitle: title }),
//         updateTestDetail: (detail) => set({ testDetail: detail }),
//         updateTechnologyUsed: (tech) => set({ technology_Used: [...tech] }),
//         updateDuration: (time) => set({ duration: time }),
//         updateTest: (data) => set({ questions: data }),
//         updateProfile:(data)=>set({profile:data}),
//         clearStore: () =>
//           set({
//             testTitle: '',
//             testDetail: '',
//             profile:'',
//             technology_Used: [],
//             duration: '15',
//             questions: [],
//           }),
//       }),
//       { name: 'testStore' }
//     )
//   )
// );
export const useTestStore = create((set) => ({
  testTitle: '',
        testDetail: '',
        technology_Used: [],
        duration: 15,
        profile:'',
        questions: [],
        updateTitle: (title) => set({ testTitle: title }),
        updateTestDetail: (detail) => set({ testDetail: detail }),
        updateTechnologyUsed: (tech) => set({ technology_Used: [...tech] }),
        updateDuration: (time) => set({ duration: time }),
        updateTest: (data) => set({ questions: data }),
        updateProfile:(data)=>set({profile:data}),
        clearStore: () =>
          set({
            testTitle: '',
            testDetail: '',
            profile:'',
            technology_Used: [],
            duration: '15',
            questions: [],
          })
}));